import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import axios from 'axios';
import Loading from '../../components/Loading';
import Helmet from 'react-helmet';
import Spin2Win from '../../components/Spin2Win.js';
import Notification from '../../components/Notification.js';
import Step from './Step';

import LoadingSmall from '../../components/LoadingSmall.js';

import Mystore from './Platform/Mystore.js';
import CartReminder from './CartReminder.js';
import Popup from './Popup.js';
import General from '../../modules/General';
import GeneralHelper from '../../helpers/General';
class Setup extends React.Component {
	constructor(props) {
		super(props);

		this.language = {};
		this.language['norwegian'] = {
			step:'Steg',
			custom_selected:'Vi ønsker å bygge støtte for flere platformer. Ta kontakt med oss på hi@crall.io for å se på muligheten for å bygge støtte for akkurat din platform.',
			none_of_them:'Ingen av dem',
			of:'av',
			name:'Navn',
			platform:'Velg leverandør',
			name_is_required:'Du må oppgi navnet ditt.',
			step1_title:'Navn',
			step1_description:'Hva er navnet ditt? Dette vil være synlig for dine kollegaer.',
			step2_title:'Leverandør',
			step2_description:'Hvordan platform eller leverandør av nettbutikk bruker du ?',
			start:'Til kontrollpanelet',
			step0_description:'Hvilket språk ønsker du at veiviseren skal være på?',
			language:'Språk',
			company_name:'Firmanavn',
			company_is_required:'Vi trenger firmanavnet for å komme oss videre.',
			ask_for_company_description:'Hva er navnet på firmaet ditt?',
            select_country:'Land',
            ask_country_description:'Velg landet hvor bedriften din er registrert. Dette er viktig i forhold til moms.'

		};

		this.language['english'] = {
			step:'Step',
			custom_selected:'Vi ønsker å bygge støtte for flere platformer. Ta kontakt med oss på hi@crall.io for å se på muligheten for å bygge støtte for akkurat din platform.',
			none_of_them:'None of them',
			of:'of',
			name:'Name',
			platform:'Select platform',
			name_is_required:'We need your name.',
			step1_title:'Name',
			step1_description:'What is your name? This will be visible for other team members.',
			step2_title:'Platform',
			step2_description:'Which platform is your shop using?',
			start:'Go to dashboard',
			step0_description:'What language do you want in the configuration wizard?',
			language:'Language',
			company_name:'Copmany name',
			company_is_required:'We need your company name.',
			ask_for_company_description:'What is the name of your company?',
            select_country:'Country',
            ask_country_description:'Select the country where your company is registered. This is important because of VAT calculation.'
        };

		this.steps = [
			'step0',
            'ask_for_country',
            'step1',
			'ask_for_company_name',
			'step2',
			'step3',
			'step4',
			'step5',
			'step6',
		];


		this.state = {
			isLoading:false,
			isError:false,
			error:false,
			info:false,
			language:'norwegian',
			step:0,
			company_name:'',
			name:'',
			platform:'Mystore',
			country:'Norway',
		}
		this.getLanguage = this.getLanguage.bind(this);
		this.handleChangeLangauge = this.handleChangeLangauge.bind(this);
		this.renderStep = this.renderStep.bind(this);
		this.handleLanguageSelect = this.handleLanguageSelect.bind(this);
		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleNextStep = this.handleNextStep.bind(this);
		this.mystoreComplete = this.mystoreComplete.bind(this);
		this.finish = this.finish.bind(this);
		this.handleButtonDown = this.handleButtonDown.bind(this);
		this.dashboard = this.dashboard.bind(this);

	}

	dashboard() {
		location.reload();
	}

	mystoreComplete() {
		this.handleNextStep();
	}

	handleNextStep() {
		if(this.validate()) {
			this.setState({'error':false,'step':this.state.step+1});
		}
	}

	validate() {
		let status = true;

		if(!this.steps[this.state.step]) {
			return status;
		}

		switch(this.steps[this.state.step]) {
			case 'step1':
				if(this.state.name.length <= 2) {
					status = false;
				}
				this.setState({error:this.getLanguage('name_is_required')})
			break;

            case 'ask_for_company_name':
				if(this.state.company_name.length <= 2) {
					status = false;
				}
				this.setState({error:this.getLanguage('company_is_required')})
			break;
		}

		return status;
	}

	componentWillMount() {
		if(this.props.general.settings.ONBOARDING == '1') {
			this.props.router.push(General.Link('/dashboard'));
			return;
		}
		this.addBodyClass(true);
	}

	handleLanguageSelect(e) {
		this.setState({'step':1});
	}

	getLanguage(str) {
		return this.language[this.state.language][str];
	}

	finish() {
		this.setState({isLoading:true});
		let data = {
			name:this.state.name,
			language:this.state.language,
			company_name:this.state.company_name,
			country:this.state.country,
		};
		axios.post('/ajax/setup_complete',data).then(res => {
			this.setState({isLoading:false});
		})
		this.handleNextStep();
	}

    handleButtonDown(e) {
		if(e.key == 'Enter') {
			this.handleNextStep();
		}
	}

	handleInputChange(e) {
		if(e.target.getAttribute('data-id') == 'platform') {
			if(e.target.value == 'Custom') {
				this.setState({info:this.getLanguage('custom_selected')});
			}else{
				this.setState({info:false});
			}
		}
		this.setState({
			[e.target.getAttribute('data-id')]:e.target.value
		});
	}

	step0() {
		return (
			<Step info={this.state.info} language={this.state.language} title={this.getLanguage('language')} handleContinue={this.handleLanguageSelect} description={this.getLanguage('step0_description')}>
				<div className="form-group col-sm-12">
	            	<label className="form-control-label">Select language</label>
	                <select className="form-control form-control-lg" value={this.state.language} onChange={this.handleChangeLangauge}>
	                    <option value="norwegian">Norsk</option>
	                    <option value="english">English</option>
	                </select>
	            </div>
			</Step>
		)
	}

    ask_for_country() {
		return (
			<Step info={this.state.info} language={this.state.language} title={this.getLanguage('select_country')} error={this.state.error} handleContinue={this.handleNextStep} description={this.getLanguage('ask_country_description')}>
				<div className="form-group col-sm-12">
	            	<label className="form-control-label">{this.getLanguage('select_country')}</label>
	                <select className="form-control form-control-lg" value={this.state.country} onChange={this.handleChangeCountry}>
                        {GeneralHelper.countries().map((country,i) => {
                            return <option key={i} value={country}>{country}</option>
                        })}
	                </select>
	            </div>
			</Step>
		)
	}

	step1() {
		return (
			<Step info={this.state.info} language={this.state.language} title={this.getLanguage('step1_title')} error={this.state.error} handleContinue={this.handleNextStep} description={this.getLanguage('step1_description')}>
				<div className="form-group col-sm-12">
	            	<label className="form-control-label">{this.getLanguage('name')}</label>
	               	<input type="text" data-id="name" onKeyDown={this.handleButtonDown} className="form-control form-control-lg" value={this.state.name} onChange={this.handleInputChange} />
	            </div>
			</Step>
		)
	}

	ask_for_company_name() {
		return (
			<Step info={this.state.info} language={this.state.language} title={this.getLanguage('company_name')} error={this.state.error} handleContinue={this.handleNextStep} description={this.getLanguage('ask_for_company_description')}>
				<div className="form-group col-sm-12">
	            	<label className="form-control-label">{this.getLanguage('company_name')}</label>
	               	<input type="text" data-id="company_name" onKeyDown={this.handleButtonDown} className="form-control form-control-lg" value={this.state.company_name} onChange={this.handleInputChange} />
	            </div>
			</Step>
		)
	}

	step2() {
		return (
			<Step info={this.state.info} language={this.state.language} title={this.getLanguage('step2_title')} error={this.state.error} handleContinue={this.handleNextStep} description={this.getLanguage('step2_description')}>
				<div className="form-group col-sm-12">
	            	<label className="form-control-label">{this.getLanguage('platform')}</label>
	               	<select className="form-control form-control-lg" data-id="platform" value={this.state.platform} onChange={this.handleInputChange}>
	                    <option value="Mystore">Mystore.no</option>
	                    <option value="Custom">{this.getLanguage('none_of_them')}</option>
	                </select>
	            </div>
			</Step>
		)
	}

	step3() {
		let platform = null;

		switch(this.state.platform) {
			case 'Mystore':
				platform = <Mystore handleComplete={this.mystoreComplete} language={this.state.language} handleSubmit={this.submitPlatform} />
			break;
		}

		return platform;
	}

	step4() {
		return (
			<CartReminder handleComplete={this.handleNextStep} language={this.state.language}  />
		)
	}

	step5() {
		return (
			<Popup handleComplete={this.finish} language={this.state.language}  />
		)
	}

	step6() {
		return (
			<div className="col-sm-12">
				<div className="checkmark">
					<svg  id="Layer_1" x="0px" y="0px" viewBox="0 0 161.2 161.2" enableBackground="new 0 0 161.2 161.2" >
						<path className="path" fill="none" stroke="#526069" strokeMiterlimit="10" d="M425.9,52.1L425.9,52.1c-2.2-2.6-6-2.6-8.3-0.1l-42.7,46.2l-14.3-16.4c-2.3-2.7-6.2-2.7-8.6-0.1c-1.9,2.1-2,5.6-0.1,7.7l17.6,20.3c0.2,0.3,0.4,0.6,0.6,0.9c1.8,2,4.4,2.5,6.6,1.4c0.7-0.3,1.4-0.8,2-1.5c0.3-0.3,0.5-0.6,0.7-0.9l46.3-50.1C427.7,57.5,427.7,54.2,425.9,52.1z"/>
						<circle className="path" fill="none" stroke="#526069" strokeWidth="4" strokeMiterlimit="10" cx="80.6" cy="80.6" r="62.1"/>
						<polyline className="path" fill="none" stroke="#526069" strokeWidth="6" strokeLinecap="round" strokeMiterlimit="10" points="113,52.8 74.1,108.4 48.2,86.4 "/>
					</svg>
				</div>
				<div className="col-sm-12 m-t-20 m-b-20">
					<button onClick={this.dashboard} className="btn btn-lg btn-block btn-success">{this.getLanguage('start')} <i className="icon wb-arrow-right"></i></button>
				</div>
			</div>


		)
	}

	renderStep() {
		return this[this.steps[this.state.step]]();

	}


	componentWillUnmount() {
		this.addBodyClass(false);
	}

	handleChangeLangauge(e) {
		this.setState({language:e.target.value});
	}

    handleChangeCountry(e) {
		this.setState({country:e.target.value});
	}


	addBodyClass(add) {
		if(add) {
			document.body.classList.add('layout-full');
		}else{
			document.body.classList.remove('layout-full');
		}
	}


	render() {
		if(this.state.isLoading) {
			return (
				<Loading error={this.state.isError} />
			);
		}

		return (

			<div className="height-100" id="setup">
			 	<Helmet title="Setup | Crall.io" />

			 	<div className="logo">
			 		<img src="/assets/images/logo.png" style={{width:'130px',marginLeft:'20px'}} />
			 	</div>

			 	<div className="row">
					<div className="m-t-40 offset-sm-4 col-sm-4">
						{this.renderStep()}
						{this.state.step > 0 ?
							<div className="col-sm-12 m-t-10 font-size-10 text-center">
								<span>{this.getLanguage('step')} {this.state.step} {this.getLanguage('of')} {this.steps.length-1}</span>
							</div>
						:null}
					</div>
			 	</div>



			 </div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		auth:state.auth,
		general:state.general,
	}
}

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({},dispatch)
}


Setup = connect(mapStateToProps,mapDispatchToProps)(Setup);
export default Setup;



// WEBPACK FOOTER //
// ./containers/setup/setup.js